import moment from "moment";

export const getSlots = (Course, Bookingdate, BookingTime) => {
  const practicalHours = Number(Course?.practical) || 0;
  const theoryHours = Number(Course?.theory) || 0;
  const courseDurationHours = practicalHours + theoryHours;
  const daysRequired = Math.ceil(courseDurationHours / 2); // Assuming 2 hours per day for course

  let currentDate = moment(Bookingdate);
  let validDaysCount = 0;
  const dateSlots = [];

  // Clone the current date to manipulate it without affecting the original date
  let overallEndDate = currentDate.clone();

  // Iterate until we reach the required number of valid days
  while (validDaysCount < daysRequired) {
    const dayOfWeek = overallEndDate.day();
    // Skip weekends (0 = Sunday, 6 = Saturday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      // Add the date slot object with time and status
      dateSlots.push({
        id: dateSlots.length + 1,
        date: overallEndDate.format("DD-MM-YYYY"),
        time: BookingTime,  // You can adjust the time slot logic as per your requirements
        status: 1,
        instructorFeedback: [],
        customerFeedback: [],
        isClaimed: false
      });

      validDaysCount++;
    }

    // Move to the next day
    overallEndDate.add(1, "days");
  }

  return dateSlots;
};
